import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import React from "react";
import { Link } from "react-router-dom";
import { ResetPasswordFromToken } from "src/app/interfaces/Index";
import { SystemSettingService, UserService } from "src/app/services/Index";
import { colours } from "src/app/Styles";
import "./AdminResetPassword.css";

type Props = {};
type State = {
	isLoading: boolean;
	passwordComplexityRules: string;
	requestSubmitted: boolean;
	resetPasswordFromToken: ResetPasswordFromToken;
	tokenChecked: boolean;
	validationErrors: {[key: string]: string[]};
};
export class AdminResetPassword extends React.Component<Props, State> {
	toast: any;

	constructor(props: Props) {
		super(props);
		this.state = {isLoading: false, passwordComplexityRules: "", requestSubmitted: false, resetPasswordFromToken: new ResetPasswordFromToken(), tokenChecked: false, validationErrors: {} as any};
	}

	componentDidMount() {
		document.documentElement.classList.add("admin-zoom");
		this.getPasswordComplexityRules();
		this.getToken();
	}

	async getPasswordComplexityRules() {
		const res = await SystemSettingService.passwordComplexityRules();
		if (res && res.ok) {
			const resDetails = await res.json();
			this.setState({passwordComplexityRules: resDetails.rules});
		}
	}

	async getToken() {
		const token = location.href.substring(location.href.lastIndexOf("/") + 1);

		const res = await UserService.checkPasswordResetToken(token);
		if (res && res.ok) {
			this.setState({resetPasswordFromToken: {token: token}});
		}

		this.setState({tokenChecked: true});
	}

	componentWillUnmount() {
		document.documentElement.classList.remove("admin-zoom");
	}

	render() {
		return (
			<>
				<div className="reset-password" style={{background: "url(/assets/shutterstock_1082131991.jpg)", backgroundSize: "cover"}}>
					<div className="wrapper">
						<div className="panel">
							<Link style={{backgroundColor: colours.primary, display: "block", height: 80, marginBottom: 30, padding: 10, textDecoration: "none", width: "100%"}} to=".">
								<img src="/assets/LogoLadleWhite_Small.png" style={{height: 60}}></img>
							</Link>							
							{ this.state.tokenChecked === false ? 
								<>
								</>
							: this.state.requestSubmitted ?
								<>
									<p>Your password has been successfully reset.</p>
									<p>You may now log in using one of the below links:</p>
									<p><a href="/login">Log in as a Customer</a></p>
									<p><a href="/chef">Log in as a Chef</a></p>
								</>
							: this.state.resetPasswordFromToken.token === undefined || this.state.resetPasswordFromToken.token === '' ?
								<>
									<p>Invalid token provided. Either you have provided the wrong token, or your token has expired and can no longer be used.</p>
									<p>Please visit the <a href="/forgot-password">Forgotten Password Page</a> in order to request a new token.</p>
								</>
							:
								<form onSubmit={(e) => this.resetPassword(e) }>
									<p style={{color: colours.primary, fontSize: 35, marginBottom: 30}}>Reset Password</p>
									<div className="field">
										<InputText disabled={this.state.isLoading} id="newPassword" onChange={(e) => this.setState({resetPasswordFromToken: {...this.state.resetPasswordFromToken, newPassword: e.target.value}})} placeholder="Password" style={{backgroundColor: colours.quinary, padding: "0.5rem", width: "75%"}} type="password" value={this.state.resetPasswordFromToken.newPassword}/>
										{this.state.validationErrors.newPassword &&
											<small className="p-error" id="newPassword-help" style={{display: "block", fontSize: 12}}>{this.state.validationErrors.newPassword.join(" ")}</small>
										}
									</div>
									<div className="field">
										<InputText disabled={this.state.isLoading} id="confirmNewPassword" onChange={(e) => this.setState({resetPasswordFromToken: {...this.state.resetPasswordFromToken, confirmNewPassword: e.target.value}})} placeholder="Confirm Password" style={{backgroundColor: colours.quinary, padding: "0.5rem", width: "75%"}} type="password" value={this.state.resetPasswordFromToken.confirmNewPassword}/>
										{this.state.validationErrors.confirmNewPassword &&
											<small className="p-error" id="confirmNewPassword-help" style={{display: "block", fontSize: 12}}>{this.state.validationErrors.confirmNewPassword.join(" ")}</small>
										}
									</div>
									<p>{this.state.passwordComplexityRules}</p>
									<Button iconPos="right" label="Reset Password" loading={this.state.isLoading} onClick={(e) => this.resetPassword(e)} style={{backgroundColor: colours.primary, borderColor: colours.primary, textTransform: "uppercase", width: "75%"}}/>
								</form>
							}
						</div>
					</div>
				</div>
				<Toast ref={(el) => this.toast = el}></Toast>
			</>
		);
	}

	async resetPassword(e: any) {
		e.preventDefault();
		this.setState({isLoading: true, validationErrors: {} as any});
		const res = await UserService.resetPasswordFromToken(this.state.resetPasswordFromToken);
		if (res && res.ok) {
			this.toast.show({closable: false, detail: "Password reset successful.", life: 5000, severity: "success", summary: "Success."});
			this.setState({requestSubmitted: true});
		} else {
			const resDetails = await res.json();
			let toastDetail = "Please try again later.";
			if (resDetails.error.includes("Invalid Token")) toastDetail = resDetails.error;
			this.toast.show({closable: false, detail: toastDetail, life: 5000, severity: "error", summary: "Something went wrong!"});
			if (resDetails.validationErrors) this.setState({validationErrors: resDetails.validationErrors});
		}
		this.setState({isLoading: false});
	}
}